import { render, staticRenderFns } from "./Quoted.vue?vue&type=template&id=6d122538&scoped=true"
import script from "./Quoted.vue?vue&type=script&lang=js"
export * from "./Quoted.vue?vue&type=script&lang=js"
import style0 from "./Quoted.vue?vue&type=style&index=0&id=6d122538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d122538",
  null
  
)

export default component.exports